import React, { useEffect } from 'react';
import Script from 'next/script';
import DefaultLayout from '@/components/layout/DefaultLayout';
import CookieBanner from '@/lib/Cookie';
import NextNProgress from 'nextjs-progressbar';
import '../sass/fhnw.scss';

function MyApp({ Component, pageProps }) {
  useEffect(() => {
    window.bootstrap = require('bootstrap/dist/js/bootstrap');

    let prevScrollPos = window.scrollY;

    const scrollFnc = () => {
      const currentScrollPos = window.scrollY;
      const navBar = document.querySelector('.navbar');
      const article = document.querySelector('article');

      if (!navBar.classList.contains('paas')) {
        if (prevScrollPos < currentScrollPos) {
          navBar.classList.remove('fixed-top');
          article.classList.remove('mt-6');
        } else {
          navBar.classList.add('fixed-top');
          article.classList.add('mt-6');
        }
      }

      prevScrollPos = currentScrollPos;
    };

    window.addEventListener('scroll', scrollFnc);

    return () => window.removeEventListener('scroll', scrollFnc);
  });

  return (
    <>
      <NextNProgress
        color="#28a745"
        startPosition={0.3}
        stopDelayMs={200}
        height={1}
        showOnShallow={true}
      />

      <DefaultLayout>
        <Component {...pageProps} />
        <CookieBanner />
      </DefaultLayout>
      <Script
        id="default"
        src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/js/default.js`}
        strategy="afterInteractive"
        defer
      />
      <Script
        id="cookieconsent"
        src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/js/cookieconsent.js`}
        strategy="afterInteractive"
        defer
      />
    </>
  );
}

export default MyApp;
